import { useTranslation } from "@i18n";
import { useRef, useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { GrClose } from "react-icons/gr";
import { assignTasksToSchedule, getScheduleDetails } from "../../../actions/task";
import { unassignedTasksUrl } from "../../../services/dataManager";
import SlickGrid1 from "../../../cubeComponent/html/SlickGrid1";
import ButtonComponent from "../../../cubeComponent/form/ButtonComponent";

import { renderUserTag } from "@CubeComponents/html/userTagDom";
function TasksList(props: any) {
  const { t } = useTranslation();
  const dataGrid = useRef<any>(null);
  const dispatch = useDispatch();
  const scheduleId = props.scheduleId;
  const projectId = props.projectId;
  const spaceId = props.spaceId;

  const [selectedTasks, setSelectedTasks] = useState([]);

  const query = useMemo(
    () => ({
      params: {
        scheduleId,
        projectId,
        spaceId,
      },
    }),
    [scheduleId, projectId, spaceId],
  );

  const rowSelected = () => {
    if (dataGrid.current) {
      const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];
      setSelectedTasks(selectedRecords.map((task) => task._id));
    }
  };

  const addTaskToSchedule = async () => {
    const selectedData = dataGrid.current?.dataView?.getAllSelectedItems() || [];
    const taskIds = selectedData.map((task) => task._id);
    await dispatch(
      assignTasksToSchedule({
        ganttId: scheduleId,
        selectedTasks: taskIds,
        projectId,
      }),
    );
    setSelectedTasks([]);
    props.refreshGrid();
    dispatch(getScheduleDetails({ scheduleId }));
  };

  const addedByFormatter = (row, cell, value, columnDef, dataContext) => {
    const { _id } = dataContext.createdBy || {};
    if (!_id) return "";
    const container = document.createElement("div");
    renderUserTag(container, { id: _id });
    return container;
  };

  const columnDefinitions = useMemo(
    () => [
      {
        id: "title",
        field: "title",
        name: t("Title"),
        minWidth: 150,
        clipMode: "EllipsisWithTooltip",
      },
      {
        id: "createdBy",
        field: "createdBy.fullName",
        name: t("Assignee"),
        minWidth: 150,
        formatter: addedByFormatter,
        // _valueGetter returns the user ID so the formatter can render user info
        _valueGetter: (row: any) => row?.createdBy?._id,
        // For excel export, use the display name
        _excelValueGetter: (row: any) => row?.createdBy?.fullName || row?.createdBy?._id || "",
        disableFiltering: true,
        disableSorting: true,
        disableGrouping: true,
      },
    ],
    [],
  );

  const getGridComponent = useCallback(
    () => (
      <SlickGrid1
        ref={dataGrid}
        remoteDataSource={unassignedTasksUrl}
        query={query}
        columnDefinitions={columnDefinitions as any}
        onSelectedRowIdsChanged={rowSelected}
        rowHeight={68}
        gridHeight="100%"
        enableFilteringOption
        enableSortingOption
        enableColumnChooser
        infiniteScroll
        hideNoDataIllustration
      />
    ),
    [query, columnDefinitions],
  );

  return (
    <div className="fixed inset-0 z-[1000] bg-[var(--background-scrim)]">
      <div className="fixed start-1/2 top-1/2 h-[70%] w-[37.5rem] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-[2rem]">
        <div className="mb-[1rem] flex w-full flex-row justify-between">
          <div className="text-[1.375rem] font-semibold">{t("Existing Tasks")}</div>
          <GrClose size={20} className="cursor-pointer" onClick={() => props.setTaskModal(false)} />
        </div>
        <div className="h-[80%]">{getGridComponent()}</div>
        <div className="mt-[2rem] flex flex-row justify-between">
          <ButtonComponent buttonType="gradientButton" disabled={selectedTasks.length == 0} onClick={addTaskToSchedule}>
            {t("Add")}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

export default TasksList;
